/* eslint-disable prefer-promise-reject-errors */
import httpCodes from 'constants/httpCodes';
import getHeaders from './getHeaders';

const MAX_AUTH_ATTEMPTS = 5;

const httpClient = async (url, options = {}, upload, authAttempt = 0) => {
  try {
    const response = await fetch(url, {
      headers: getHeaders(true, upload),
      ...options,
    });

    if (response.status === httpCodes.notAuthorized) {
      if (authAttempt >= MAX_AUTH_ATTEMPTS) {
        return Promise.reject({
          message: 'Internal error: Not authorized',
        });
      }

      if (window.getAccessTokenSilently) {
        await window.getAccessTokenSilently({
          ignoreCache: true,
        });
        return httpClient(url, options, upload, authAttempt + 1);
      }
    }

    let json = {};
    let body = {};

    body = await response.text();
    try {
      json = JSON.parse(body);
    } catch (e) {
      json = body;
    }

    if (response.status === httpCodes.badRequest) {
      return Promise.reject({
        message: json.message,
      });
    }

    if (
      response.status < httpCodes.minSuccess ||
      response.status > httpCodes.maxSuccess
    ) {
      return Promise.reject({
        message: json.message,
        status: response.status,
      });
    }
    return Promise.resolve({
      status: response.status,
      headers: response.headers,
      body,
      json,
    });
  } catch (e) {
    return Promise.reject({
      message: e.message,
    });
  }
};

export default httpClient;
